var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 9,
    x: 22.75,
    y: 1,
    fill: "#78909c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    x: 19,
    y: 4.75,
    fill: "#78909c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 9,
    x: 40.75,
    y: 19,
    fill: "#5c6bc0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    x: 37,
    y: 22.75,
    fill: "#5c6bc0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 9,
    x: 4.75,
    y: 19,
    fill: "#78909c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    x: 1,
    y: 22.75,
    fill: "#78909c"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 9,
    x: 22.75,
    y: 37,
    fill: "#5c6bc0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    x: 19,
    y: 40.75,
    fill: "#5c6bc0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 3,
    x: 15,
    y: 22,
    fill: "#e8762d"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 17,
    x: 22,
    y: 15,
    fill: "#e8762d"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 11,
    y: 6,
    fill: "#ffa000"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 5,
    y: 12,
    fill: "#ffa000"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 34,
    y: 6,
    fill: "#607d8b"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 28,
    y: 12,
    fill: "#607d8b"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 11,
    y: 27,
    fill: "#c62828"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 5,
    y: 33,
    fill: "#c62828"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 34,
    y: 27,
    fill: "#0d47a1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 28,
    y: 33,
    fill: "#0d47a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableau);
export default __webpack_public_path__ + "static/media/tableau.61c8db57bf17bbc58bdcc6b039d76e5d.svg";
export { ForwardRef as ReactComponent };